import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';

import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {CoreMenuService} from '@core/components/core-menu/core-menu.service';
import {StorageService} from '../../../app/shared/services/storage.service';
import {GlobalService} from '../../../app/shared/services/global.service';

@Component({
    selector: '[core-menu]',
    templateUrl: './core-menu.component.html',
    styleUrls: ['./core-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoreMenuComponent implements OnInit, OnDestroy {
    currentUser: any;

    @Input()
    layout = 'vertical';

    @Input()
    menu: any;
    public user: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     *
     * @param {ChangeDetectorRef} _changeDetectorRef
     * @param {CoreMenuService} _coreMenuService
     * @param {GlobalService} _globalService
     */
    constructor(private _changeDetectorRef: ChangeDetectorRef, private _coreMenuService: CoreMenuService,
                private _globalService: GlobalService) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Set the menu either from the input or from the service
        this.menu = this.menu || this._coreMenuService.getCurrentMenu();
        this.user = StorageService.getItem('self');

        // Re-filter the menu whenever the logged-in user (and so the role) changes
        this._globalService.self$.pipe(takeUntil(this._unsubscribeAll)).subscribe(self => {
            this.user = self || StorageService.getItem('self');
            this._changeDetectorRef.markForCheck();
        });

        // Subscribe to the current menu changes
        this._coreMenuService.onMenuChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            this.currentUser = this._coreMenuService.currentUser;

            // Load menu
            this.menu = this._coreMenuService.getCurrentMenu();

            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
